module.exports = __webpack_public_path__ + "img/phone.178cc149.svg";